import axios from 'axios';
import $ from "jquery";


const connexion = {

    init() {
        document.querySelectorAll('.toggle-password').forEach(btn => {
            btn.addEventListener('click', function () {
                const input = document.querySelector(this.dataset.target);

                if (input.type === "password") {
                    input.type = "text";
                    // this.textContent = '<i class="fa-solid fa-eye-slash"></i>'; // icône alternative
                } else {
                    input.type = "password";
                    //this.textContent = '<i class="fa-solid fa-eye"></i>';
                }
            });
        });
    },
    handleGoogleResponseCreation: function (response) {
        const token = response.credential;
        axios.post('google-callback/creation', {credential: token, context: 'creation'})
            .then((res) => {
                if (res.data.status === 'success') {
                    window.location.href = _SITE_URL + 'tinego-compte';
                } else {
                    $(".google_error").html("<span>" + res.data.message + "</span>");
                    return false;
                }
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Erreur côté serveur :", error.response.data);
                } else if (error.request) {
                    console.error("Aucune réponse reçue :", error.request);
                } else {
                    console.error("Erreur lors de la configuration de la requête :", error.message);
                }
            });
    },
    handleGoogleResponse: function (response) {

        const token = response.credential;

        // Effectuer l'appel avec Axios
        axios.post('google-callback/connexion', {credential: token, context: 'connexion'})
            .then((res) => {
                console.log("Réponse du serveur :", res.data); // Vérifie ce qui est renvoyé
                if (res.data.status === 'success') {
                    window.location.href = _SITE_URL + 'tinego-compte';
                } else {
                    $("._contain_error_connexion").html("<span class='_error_connexion _error'>"+res.data.message+"</span>");
                }
            })
            .catch((error) => {
                console.error("Erreur lors de la requête :", error.response ? error.response.data : error.message);
                if (error.response) {
                    console.error("Erreur côté serveur :", error.response.data);
                } else if (error.request) {
                    console.error("Aucune réponse reçue :", error.request);
                } else {
                    console.error("Erreur lors de la configuration de la requête :", error.message);
                }
            });
    },

    creationCompte: function () {


        const form = document.getElementById('form-creation-compte');

        // //creation bouton google
        // const signinButton = form.querySelector('.g_id_signin');
        // if (signinButton) {
        //     signinButton.remove();
        // }
        //
        // const newButton = document.createElement('div');
        // newButton.className = 'g_id_signin _creation';
        // form.querySelector('#g_id_onload_creation').appendChild(newButton);
        //
        // // Initialiser l'API Google Sign-In
        // google.accounts.id.initialize({
        //     client_id: "166277857704-84itjm2ggvs0p6hibk0utmhnl8fg26rj.apps.googleusercontent.com",
        //     callback: connexion.handleGoogleResponseCreation,
        //     auto_select: false,
        // });
        //
        // // Rendre le bouton Google Sign-In
        // google.accounts.id.renderButton(newButton, {
        //     theme: 'outline',
        //     size: 'large',
        //     text: 'signup_with',
        //     shape: 'pill'
        // });
        //
        // google.accounts.id.prompt();
        //creation bouton google

        if (!form) {
            console.error("Formulaire avec l'ID 'form-creation-compte' introuvable !");
            return;
        }

        // $(document).on("click", "button[value=_creation_compte]", function (e) {
        //     if (!connexion.controlCreation()) {
        //         e.preventDefault();
        //         return false;
        //     } else {
        //         $("#form-creation-compte").submit();
        //     }
        // });

        form.addEventListener('focusout', function (e) {
            const input = e.target;
            if (input.tagName === 'INPUT') {
                switch (input.name) {
                    case 'user_name':
                    case 'user_surname':
                        if (!input.value) {
                            input.classList.add('_invalidate');
                            connexion.showTooltip(input, 'Champ obligatoire.');
                        } else {
                            input.classList.remove('_invalidate');
                            connexion.hideTooltip(input);
                        }
                        break;
                    case 'user_email':
                        if (!connexion.validateEmail(input.value)) {
                            input.classList.add('_invalidate');
                            connexion.showTooltip(input, 'Veuillez entrer un email valide.');
                        } else {
                            input.classList.remove('_invalidate');
                            connexion.hideTooltip(input);
                        }
                        break;
                    case 'user_phone':
                        if (input.value != "" && !connexion.validatePhone(input.value)) {
                            input.classList.add('_invalidate');
                            connexion.showTooltip(input, 'Veuillez entrer un numéro de téléphone valide.');
                        } else {
                            input.classList.remove('_invalidate');
                            connexion.hideTooltip(input);
                        }
                        break;
                    case 'user_pwd':
                        if (!connexion.validatePassword(input.value)) {
                            input.classList.add('_invalidate');
                            connexion.showTooltip(input, 'Le mot de passe doit contenir au moins 8 caractères, avec une majuscule, une minuscule et un chiffre.');
                        } else {
                            input.classList.remove('_invalidate');
                            connexion.hideTooltip(input);
                        }
                        break;
                    case 'user_pwd_confirm':
                        const passwordField = form.querySelector('[name="user_pwd"]');
                        if (input.value !== passwordField.value) {
                            input.classList.add('_invalidate');
                            connexion.showTooltip(input, 'Les mots de passe ne correspondent pas.');
                        } else {
                            input.classList.remove('_invalidate');
                            connexion.hideTooltip(input);
                        }
                        break;
                }
            }
        });
    },
    controlCreation: function () {

        document.querySelectorAll('.tooltip-error').forEach(tooltip => {
            tooltip.style.display = 'none';
        });

        const nameField = document.querySelector('[name="user_name"]');
        const surnameField = document.querySelector('[name="user_surname"]');
        const emailField = document.querySelector('[name="user_email"]');
        const phoneField = document.querySelector('[name="user_phone"]');
        const passwordField = document.querySelector('[name="user_pwd"]');
        const confirmPasswordField = document.querySelector('[name="user_pwd_confirm"]');

        let isValid = true;

        // Vérifier le nom
        if (!nameField.value) {
            nameField.classList.add('_invalidate');
            isValid = false;
        } else {
            nameField.classList.remove('_invalidate');
        }

        // Vérifier le prénom
        if (!surnameField.value) {
            surnameField.classList.add('_invalidate');
            isValid = false;
        } else {
            surnameField.classList.remove('_invalidate');
        }

        // Vérifier l'email
        if (!this.validateEmail(emailField.value)) {
            emailField.classList.add('_invalidate');
            isValid = false;
        } else {
            emailField.classList.remove('_invalidate');
            this.hideTooltip(emailField);
        }

        // Vérifier le téléphone
        if (phoneField.value != "" && !this.validatePhone(phoneField.value)) {
            phoneField.classList.add('_invalidate');
            //this.showTooltip(phoneField, 'Veuillez entrer un numéro de téléphone valide.');
            isValid = false;
        } else {
            phoneField.classList.remove('_invalidate');
            this.hideTooltip(phoneField);
        }

        // Vérifier le mot de passe
        if (!this.validatePassword(passwordField.value)) {
            passwordField.classList.add('_invalidate');
            //this.showTooltip(passwordField, 'Le mot de passe doit contenir au moins 8 caractères, avec une majuscule, une minuscule et un chiffre.');
            isValid = false;
        } else {
            passwordField.classList.remove('_invalidate');
            this.hideTooltip(passwordField);
        }

        // Vérifier la confirmation du mot de passe
        if (passwordField.value !== confirmPasswordField.value) {
            confirmPasswordField.classList.add('_invalidate');
            //this.showTooltip(confirmPasswordField, 'Les mots de passe ne correspondent pas.');
            isValid = false;
        } else {
            confirmPasswordField.classList.remove('_invalidate');
            this.hideTooltip(confirmPasswordField);
        }

        return isValid;
    },
    // Valider l'email
    validateEmail: function (email) {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    },

    // Valider le téléphone
    validatePhone: function (phone) {
        const regex = /^[0-9\-\s]+$/;
        return regex.test(phone) && phone.length >= 10;
    },

    // Valider le mot de passe
    validatePassword: function (password) {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
        return regex.test(password);
    },
    // Afficher un tooltip d'erreur
    showTooltip: function (field, message) {
        // Cacher tous les autres tooltips
        document.querySelectorAll('.tooltip-error').forEach(tooltip => {
            tooltip.style.display = 'none';
        });

        let tooltip = field.nextElementSibling;

        // Créer un tooltip si nécessaire
        if (!tooltip || !tooltip.classList.contains('tooltip-error')) {
            tooltip = document.createElement('div');
            tooltip.className = 'tooltip-error';
            field.parentNode.appendChild(tooltip);
        }

        tooltip.textContent = message;
        tooltip.style.display = 'block';
    },

    // Cacher le tooltip d'erreur
    hideTooltip: function (field) {
        const tooltip = field.nextElementSibling;
        if (tooltip && tooltip.classList.contains('tooltip-error')) {
            tooltip.style.display = 'none';
        }
    }
};
window.connexion = connexion;
export default connexion;
